import { useState } from 'react';

/**
 * State ed helper per espandere/comprimere descrizioni inline di un set
 * di entità (mosse, spell). Pattern coerente con `SectionStartingMoves`
 * (origine) e riusato da `LevelUpStepMove`.
 *
 * Esposto come modulo separato per rispettare `react-refresh/only-export-components`
 * (non posso esportare hook + componenti dallo stesso file `.tsx`).
 */
export function useExpandedState(allVisibleIds: readonly string[]): {
  expanded: Set<string>;
  toggleExpanded: (id: string) => void;
  expandAll: () => void;
  collapseAll: () => void;
  allExpanded: boolean;
} {
  const [expanded, setExpanded] = useState<Set<string>>(() => new Set());
  const toggleExpanded = (id: string): void =>
    setExpanded((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  const expandAll = (): void => setExpanded(new Set(allVisibleIds));
  const collapseAll = (): void => setExpanded(new Set());
  const allExpanded = allVisibleIds.length > 0 && allVisibleIds.every((id) => expanded.has(id));
  return { expanded, toggleExpanded, expandAll, collapseAll, allExpanded };
}
